import React, { useMemo, Fragment } from "react";
import Table from "../table/table";
// Icons
import icoArrowOrange from "../../assets/Images/ico-arrow-orange.svg";
import icoArrowWhite from "../../assets/Images/ico-arrow-white.svg";

function TableFilters({ searchWord, selectValue, changed }) {
	const columns = useMemo(() => [
		{
			Header: "Local Authority",
			accessor: "local",
			isSortable: false,
			columns: [
				{
					Header: "",
					accessor: "local",
					columns: [
						{
							Header: "",
							accessor: "local",
						},
					],
				},
			],
		},
		{
			Header: "Region",
			accessor: "region",
			isSortable: false,
			columns: [
				{
					Header: "",
					accessor: "region",
					columns: [
						{
							Header: "",
							accessor: "region",
						},
					],
				},
			],
		},
		{
			Header: "Total Construction Investment",
			accessor: "total",
			columns: [
				{
					Header: " ",
					columns: [
						{
							Header: "2015/16",
							Icon: icoArrowOrange,
							accessor: "2015",
							isSortable: true,
						},
						{
							Header: "2020/21",
							Icon: icoArrowOrange,
							accessor: "2020",
							isSortable: true,
						},
						{
							Header: "% Change",
							accessor: "change",
							isSortable: true,
						},
					],
				},
			],
		},
		{
			Header: "General construction",
			Icon: "/Images/ico-construction.svg",
			columns: [
				{
					Header: "",
					accessor: "general",
					columns: [
						{
							Header: "2015/16",
							Icon: icoArrowWhite,
							accessor: "g2015",
							isSortable: true,
						},
						{
							Header: "2020/21",
							Icon: icoArrowWhite,
							accessor: "g2020",
							isSortable: true,
						},
					],
				},
			],
		},
		{
			Header: "Building construction",
			Icon: "/Images/ico-building-construction.svg",
			accessor: "building",
			columns: [
				{
					Header: "",
					accessor: "building",
					columns: [
						{
							Header: "2015/16",
							Icon: icoArrowWhite,
							accessor: "b2015",
							isSortable: true,
						},
						{
							Header: "2020/21",
							Icon: icoArrowWhite,
							accessor: "b2020",
							isSortable: true,
						},
					],
				},
			],
		},
		{
			Header: "Open spaces",
			Icon: "/Images/ico-open-spaces.svg",
			accessor: "open",
			columns: [
				{
					Header: "",
					accessor: "open",
					columns: [
						{
							Header: "2015/16",
							Icon: icoArrowWhite,
							accessor: "o2015",
							isSortable: true,
						},
						{
							Header: "2020/21",
							Icon: icoArrowWhite,
							accessor: "o2020",
							isSortable: true,
						},
					],
				},
			],
		},
		{
			Header: "Roads",
			Icon: "/Images/ico-road.svg",
			accessor: "roads",
			columns: [
				{
					Header: "",
					accessor: "roads",
					columns: [
						{
							Header: "2015/16",
							Icon: icoArrowWhite,
							accessor: "r2015",
							isSortable: true,
						},
						{
							Header: "2020/21",
							Icon: icoArrowWhite,
							accessor: "r2020",
							isSortable: true,
						},
					],
				},
			],
		},
		{
			Header: "Bridges",
			Icon: "/Images/ico-bridges.svg",
			accessor: "bridges",
			columns: [
				{
					Header: "",
					accessor: "bridges",
					columns: [
						{
							Header: "2015/16",
							Icon: icoArrowWhite,
							accessor: "br2015",
							isSortable: true,
						},
						{
							Header: "2020/21",
							Icon: icoArrowWhite,
							accessor: "br2020",
							isSortable: true,
						},
					],
				},
			],
		},
	]);

	const data = useMemo(() => [
		{
			local: "Welwyn Hatfield Council",
			region: "East of England",
			2015: "£763,863",
			2020: "£4,263,983",
			change: "55%",
			g2015: "£763,863",
			g2020: "£42,639,830",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Pembrokeshire Council",
			region: "Wales",
			2015: "£930,767",
			2020: "£29,769,498",
			change: "31%",
			g2015: "N/A",
			g2020: "N/A",
			b2015: "£908,767",
			b2020: "£7,520,416",
			o2015: "N/A",
			o2020: "£8,973,631",
			r2015: "£22,000",
			r2020: "£13,275,451",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Surrey Heath Borough Council",
			region: "South East",
			2015: "£934,617",
			2020: "£18,578,063",
			change: "19%",
			g2015: "£934,617",
			g2020: "£18,578,063",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Broadland District Council",
			region: "East of England",
			2015: "£9,976",
			2020: "£180,810",
			change: "17%",
			g2015: "£9,976",
			g2020: "£180,810",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "North Norfolk District Council",
			region: "East of England",
			2015: "£461,926",
			2020: "£7,012,937",
			change: "14%",
			g2015: "£461,926",
			g2020: "£672,859",
			b2015: "N/A",
			b2020: "£6,340,077",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Braintree District Council",
			region: "East of England",
			2015: "£2,332,542",
			2020: "£28,345,905",
			change: "11%",
			g2015: "N/A",
			g2020: "N/A",
			b2015: "£1,591,122",
			b2020: "£15,065,838",
			o2015: "£598,153",
			o2020: "£182,994",
			r2015: "£143,268",
			r2020: "£13,097,073",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Stoke-on-Trent City Council",
			region: "West Midlands",
			2015: "£640,804",
			2020: "£7,618,976",
			change: "11%",
			g2015: "N/A",
			g2020: "£19,816",
			b2015: "£640,804",
			b2020: "£7,599,160",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "West Lindsey",
			region: "East Midlands",
			2015: "£314,684",
			2020: "£37,329",
			change: "11%",
			g2015: "£314,684",
			g2020: "£225,087",
			b2015: "N/A",
			b2020: "£3,507,812",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Shepway District Council ",
			region: "South East",
			2015: "£4,335,470",
			2020: "£49,774,831",
			change: "10%",
			g2015: "$4,335,470",
			g2020: "$49,774,831",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Rother District Council",
			region: "South East",
			2015: "£565,413",
			2020: "£5,980,419",
			change: "10%",
			g2015: "N/A",
			g2020: "N/A",
			b2015: "£427,088",
			b2020: "£5,128,653",
			o2015: "£123,986",
			o2020: "£34,645",
			r2015: "£1,434",
			r2020: "£817,121",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Maidstone Borough Council",
			region: "South East",
			2015: "£2,410,004",
			2020: "£24,795,978",
			change: "9%",
			g2015: "£2,410,004",
			g2020: "£24,795,978",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Gloucestershire County Council",
			region: "South West",
			2015: "£1,596,355",
			2020: "£10",
			change: "5%",
			g2015: "N/A",
			g2020: "N/A",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "£1,596,355",
			r2020: "£10,281,251",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Scarborough Borough Council",
			region: "Yorkshire and Humber",
			2015: "£2,838,711",
			2020: "£13,476,068",
			change: "4%",
			g2015: "£2,782,024",
			g2020: "£13,060,031",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "£56,687",
			r2020: "£190,168",
			br2015: "N/A",
			br2020: "£225,869",
		},
		{
			local: "Carlisle City Council",
			region: "North West",
			2015: "£2,293,931",
			2020: "£9,800,583",
			change: "3%",
			g2015: "£123,947",
			g2020: "£111,461",
			b2015: "N/A",
			b2020: "£9,686,122",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "£1,054,462",
			r2020: "£3,000",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "City & County of Swansea",
			region: "Wales",
			2015: "£36,255,564",
			2020: "£149,543,875",
			change: "3%",
			g2015: "£98,039",
			g2020: "£66,841,418",
			b2015: "£31,626,066",
			b2020: "£70,682,037",
			o2015: "£322,503",
			o2020: "£1,067,107",
			r2015: "£4,208,955",
			r2020: "£10,953,313",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Woking Borough Council",
			region: "South East",
			2015: "£14,629,393",
			2020: "£5,911,409",
			change: "3%",
			g2015: "£14,629,393",
			g2020: "£59,114,089",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Reigate and Banstead Borough Council",
			region: "South East",
			2015: "£5,193,528",
			2020: "£20,556,099",
			change: "3%",
			g2015: "£4,513,116",
			g2020: "£20,282,148",
			b2015: "£341,816",
			b2020: "£44,621",
			o2015: "£338,595",
			o2020: "£229,331",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Chorley Borough Council",
			region: "North West",
			2015: "£1,792,394",
			2020: "£6,970,126",
			change: "3%",
			g2015: "£46,531",
			g2020: "N/A",
			b2015: "£1,335,782",
			b2020: "£6,707,168",
			o2015: "£410,081",
			o2020: "£262,958",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Chelmsford Borough Council",
			region: "East of England",
			2015: "£5,500,524",
			2020: "£19,487,555",
			change: "3%",
			g2015: "£4,320,265",
			g2020: "£12,894,267",
			b2015: "£618,803",
			b2020: "£6,463,522",
			o2015: "£561,455",
			o2020: "£129,767",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Winchester City Council",
			region: "South East",
			2015: "£14,600,649",
			2020: "£48,901,594",
			change: "2%",
			g2015: "£14,600,649",
			g2020: "£48,901,594",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Watford Borough Council",
			region: "East of England",
			2015: "£543,993",
			2020: "£18,083,745",
			change: "2%",
			g2015: "N/A",
			g2020: "N/A",
			b2015: "£3,227,907",
			b2020: "£10,415,886",
			o2015: "£1,583,829",
			o2020: "£2,914,732",
			r2015: "£628,195",
			r2020: "£4,753,127",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Gateshead Metropolitan Borough Council",
			region: "North East",
			2015: "£2,826,508",
			2020: "£8,795,841",
			change: "2%",
			g2015: "N/A",
			g2020: "N/A",
			b2015: "£2,642,894",
			b2020: "£8340,515",
			o2015: "£178,614",
			o2020: "£387,248",
			r2015: "£5,000",
			r2020: "£68,078",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Ryedale District Council",
			region: "Yorkshire and Humber",
			2015: "£136,972",
			2020: "£410,569",
			change: "2%",
			g2015: "£136,972",
			g2020: "£410,569",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Spelthorne Borough Council",
			region: "South East",
			2015: "£426,036",
			2020: "£1,223,641",
			change: "2%",
			g2015: "£426,036",
			g2020: "£1,075,975",
			b2015: "N/A",
			b2020: "£147,666",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Horsham District Council",
			region: "South East",
			2015: "£2,612,867",
			2020: "£7,462,706",
			change: "2%",
			g2015: "£1,127,951",
			g2020: "£1,169,699",
			b2015: "£1,484,916",
			b2020: "£6,293,007",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Amber Valley Borough Council",
			region: "East Midlands",
			2015: "£290,000",
			2020: "£800,000",
			change: "2%",
			g2015: "£250,000",
			g2020: "£504,000",
			b2015: "N/A",
			b2020: "£250,000",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "£40,000",
			r2020: "£46,000",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "City of York",
			region: "Yorkshire and Humber",
			2015: "£3,470,000",
			2020: "£9,003,000",
			change: "2%",
			g2015: "£3,470,000",
			g2020: "£9,003,000",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "London Borough of Barnet",
			region: "London",
			2015: "£97,293",
			2020: "£209,632",
			change: "2%",
			g2015: "£38,250",
			g2020: "£70,720",
			b2015: "£38,498",
			b2020: "£41,491",
			o2015: "£41",
			o2020: "£502",
			r2015: "£20,504",
			r2020: "£96,919",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Gloucester City Council",
			region: "South West",
			2015: "£3,103,000",
			2020: "£6,428,000",
			change: "1%",
			g2015: "£3,103,000",
			g2020: "£6,428,000",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Carmarthenshire County Council",
			region: "Wales",
			2015: "£23,570,961",
			2020: "£45,601,966",
			change: "1%",
			g2015: "£19,239,930",
			g2020: "£27,292,014",
			b2015: "£0",
			b2020: "£7,856,057",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "£496,706",
			r2020: "£1,874,033",
			br2015: "£3,834,325",
			br2020: "£8,579,863",
		},
		{
			local: "North East Lincolnshire Council",
			region: "Yorkshire and Humber",
			2015: "£3,511,540",
			2020: "£6,485,270",
			change: "1%",
			g2015: "£1,265,540",
			g2020: "£1,082,270",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "£1,828,000",
			r2020: "£4,907,000",
			br2015: "£418,000",
			br2020: "£496,000",
		},
		{
			local: "Tandridge District Council",
			region: "South East",
			2015: "£4,158,173",
			2020: "£7,601,984",
			change: "1%",
			g2015: "£4,084,447",
			g2020: "£7,553,459",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "£73,726",
			r2020: "£48,525",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Sefton Metropolitan Borough Council",
			region: "North West",
			2015: "£4,077,279",
			2020: "£7,451,208",
			change: "1%",
			g2015: "£3,799,784",
			g2020: "£3,973,601",
			b2015: "£244,448",
			b2020: "£1,348,553",
			o2015: "£33,048",
			o2020: "£2,129,053",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Thurrock Council",
			region: "East of England",
			2015: "£107,214",
			2020: "£194,9671",
			change: "1%",
			g2015: "£663,580",
			g2020: "£39,462",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "£269,449",
			r2020: "£1,788,397",
			br2015: "£139,111",
			br2020: "£121,813",
		},
		{
			local: "Swale Borough Council",
			region: "South East",
			2015: "£3,146,185",
			2020: "£5,586,385",
			change: "1%",
			g2015: "£3,146,185",
			g2020: "£5,586,385",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Dartford Borough Council",
			region: "South East",
			2015: "£8,810,000",
			2020: "£15,380,000",
			change: "1%",
			g2015: "£7,950,000",
			g2020: "£11,230,000",
			b2015: "£860,000",
			b2020: "£1,500,000",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "£2,650,000",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Powys County Council",
			region: "Wales",
			2015: "£11,131,981",
			2020: "£19,093,190",
			change: "1%",
			g2015: "£63,232",
			g2020: "£554,176",
			b2015: "£6,510,268",
			b2020: "£12,007,116",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "£4,558,481",
			r2020: "£6,531,898",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Basildon District Council",
			region: "East of England",
			2015: "£29,315,756",
			2020: "£49,370,245",
			change: "1%",
			g2015: "N/A",
			g2020: "£602,036",
			b2015: "£29,158,743",
			b2020: "£47,865,089",
			o2015: "£157,013",
			o2020: "£903,120",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Leeds City Council",
			region: "Yorkshire and Humber",
			2015: "£232,441,713",
			2020: "£389,761,877",
			change: "1%",
			g2015: "£232,441,713",
			g2020: "£272,192,123",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "£117,569,754",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Barnsley Borough Council",
			region: "Yorkshire and Humber",
			2015: "£51,275,061",
			2020: "£85,283,271",
			change: "1%",
			g2015: "£36,865,304",
			g2020: "£34,495,669",
			b2015: "£12,889,904",
			b2020: "£45,116,538",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "£1,519,853",
			r2020: "£5,382,215",
			br2015: "N/A",
			br2020: "£28,885",
		},
		{
			local: "Tamworth Borough Council",
			region: "West Midlands",
			2015: "£6,732,248",
			2020: "£11,143,959",
			change: "1%",
			g2015: "£6,727,577",
			g2020: "£10,532,675",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "£611,285",
			r2015: "£4,671",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Adur & Worthing District Council",
			region: "South East",
			2015: "£5,118,222",
			2020: "£8,468,671",
			change: "1%",
			g2015: "£5,093,511",
			g2020: "£4,369,573",
			b2015: "£8,791",
			b2020: "£4,014,071",
			o2015: "£2,124",
			o2020: "£85,027",
			r2015: "£13,796",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Halton Borough Council",
			region: "North West",
			2015: "£12,620,297",
			2020: "£20,785,409",
			change: "1%",
			g2015: "£7,789,907",
			g2020: "£5,425,521",
			b2015: "£4,830,390",
			b2020: "£15,359,888",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Cheltenham Borough Council",
			region: "South West",
			2015: "£6,691,000",
			2020: "£10,986,000",
			change: "1%",
			g2015: "£6,691,000",
			g2020: "£10,986,000",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Cambridgeshire County Council",
			region: "East of England",
			2015: "£30,451,534",
			2020: "£49,827,271",
			change: "1%",
			g2015: "N/A",
			g2020: "N/A",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "£26,913,515",
			r2020: "£41,668,629",
			br2015: "£3,538,019",
			br2020: "£8,158,642",
		},
		{
			local: "South Hams District Council",
			region: "South West",
			2015: "£1,488,055",
			2020: "£2,398,226",
			change: "1%",
			g2015: "£769,055",
			g2020: "£603,226",
			b2015: "£719,000",
			b2020: "£1,795,000",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Scottish Borders Council",
			region: "Scotland",
			2015: "£34,698,962",
			2020: "£55,014,761",
			change: "1%",
			g2015: "£26,524,722",
			g2020: "£30,649,449",
			b2015: "£3,183,260",
			b2020: "£18,354,867",
			o2015: "£4,253,351",
			o2020: "£5,215,101",
			r2015: "£737,629",
			r2020: "£795,344",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Fermanagh & Omagh District Council",
			region: "Northern Ireland",
			2015: "£7,493,991",
			2020: "£11,778,027",
			change: "1%",
			g2015: "£7,493,991",
			g2020: "£11,778,027",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Telford & Wrekin Council",
			region: "West Midlands",
			2015: "£4,386,050",
			2020: "£6,825,810",
			change: "1%",
			g2015: "N/A",
			g2020: "N/A",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "£4,386,050",
			r2020: "£6,825,810",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Rotherham Metropolitan Borough Council",
			region: "Yorkshire and Humber",
			2015: "£14,135,000",
			2020: "£21,091,000",
			change: "0.4%",
			g2015: "N/A",
			g2020: "N/A",
			b2015: "£1,671,000",
			b2020: "£2,456,000",
			o2015: "£472,000",
			o2020: "£312,000",
			r2015: "£11,992,000",
			r2020: "£18,323,000",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Basingstoke & Deane Borough Council",
			region: "South East",
			2015: "£762,304",
			2020: "£1,137,240",
			change: "0.49%",
			g2015: "£8,924",
			g2020: "£200,731",
			b2015: "£21,087",
			b2020: "£513,783",
			o2015: "£732,293",
			o2020: "£422,726",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Melton Borough Council",
			region: "East Midlands",
			2015: "£106,101",
			2020: "£155,262",
			change: "0.46%",
			g2015: "N/A",
			g2020: "N/A",
			b2015: "£106,101",
			b2020: "£155,262",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "St Albans City & District Council",
			region: "East of England",
			2015: "£13,812,131",
			2020: "£19,820,643",
			change: "0.43%",
			g2015: "£955,608",
			g2020: "£1,134,831",
			b2015: "£12,856,523",
			b2020: "£18,685,812",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "South Ribble Borough Council",
			region: "North West",
			2015: "£1,259,844",
			2020: "£1,778,980",
			change: "0.41%",
			g2015: "£167,967",
			g2020: "£282,844",
			b2015: "£403,206",
			b2020: "£1,269,077",
			o2015: "£688,671",
			o2020: "£227,059",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Tendring District Council",
			region: "East of England",
			2015: "£2,343,506",
			2020: "£3,287,620",
			change: "0.40%",
			g2015: "£2,343,506",
			g2020: "£3,287,620",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Conwy County Borough Council",
			region: "Wales",
			2015: "£6,093,952",
			2020: "£8,497,565",
			change: "0.39%",
			g2015: "N/A",
			g2020: "N/A",
			b2015: "£1,987,331",
			b2020: "£2,504,059",
			o2015: "£200,318",
			o2020: "£201,282",
			r2015: "£3,906,303",
			r2020: "£5,792,224",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Charnwood Borough Council",
			region: "East Midlands",
			2015: "£233,552",
			2020: "£317,628",
			change: "0.35%",
			g2015: "N/A",
			g2020: "N/A",
			b2015: "£186,921",
			b2020: "£276,026",
			o2015: "£46,631",
			o2020: "£41,602",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Hertfordshire County Council",
			region: "East of England",
			2015: "£93,400,000",
			2020: "£126,400,000",
			change: "0.35%",
			g2015: "£52,400,000",
			g2020: "£47,700,000",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "£38,900,000",
			r2020: "£69,100,000",
			br2015: "£2,100,000",
			br2020: "£9,600,000",
		},
		{
			local: "Shropshire Council",
			region: "West Midlands",
			2015: "£27,689,940",
			2020: "£37,135,325",
			change: "0.34%",
			g2015: "£9,964,036",
			g2020: "£6,722,260",
			b2015: "£2,450,731",
			b2020: "£3,382,419",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "£15,275,174",
			r2020: "£27,030,645",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "West Dunbartonshire",
			region: "Scotland",
			2015: "£10,074,261",
			2020: "£13,115,543",
			change: "0.30%",
			g2015: "N/A",
			g2020: "N/A",
			b2015: "£1,773,321",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "£1,851,043",
			r2015: "£8,300,940",
			r2020: "£11,264,500",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Nottinghamshire County Council",
			region: "East Midlands",
			2015: "£76,322",
			2020: "£96,620",
			change: "0.27%",
			g2015: "£44,968",
			g2020: "£46,266",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "£31,354",
			r2020: "£50,354",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Swindon Borough Council",
			region: "South West",
			2015: "£22,473,254",
			2020: "£28,108,778",
			change: "0.25%",
			g2015: "£22,473,254",
			g2020: "£28,108,778",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Dorset County Council",
			region: "South West",
			2015: "£18,651,261",
			2020: "£23,311,667",
			change: "0.24%",
			g2015: "£5,958,803",
			g2020: "£6,036,907",
			b2015: "£9,578,395",
			b2020: "£14,739,352",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "£3,114,063",
			r2020: "£2,535,408",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "New Forest District Council",
			region: "South East",
			2015: "£14,919,462",
			2020: "£18,564,866",
			change: "0.24%",
			g2015: "£7,459,731",
			g2020: "£9,282,483",
			b2015: "£7,017,317",
			b2020: "£6,821,273",
			o2015: "£442,414",
			o2020: "£2,461,110",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Denbighshire Council",
			region: "Wales",
			2015: "£8,849,065",
			2020: "£10,791,716",
			change: "0.22%",
			g2015: "N/A",
			g2020: "N/A",
			b2015: "£7,731,881",
			b2020: "£9,139,037",
			o2015: "£186,415",
			o2020: "£199,731",
			r2015: "£930,769",
			r2020: "£1,452,948",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Copeland Borough Council",
			region: "North West",
			2015: "£2,310,595",
			2020: "£2,792,657",
			change: "0.21%",
			g2015: "N/A",
			g2020: "N/A",
			b2015: "£2,272,020",
			b2020: "£2,748,192",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "£38,575",
			r2020: "£44,465",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Eastleigh Borough Council",
			region: "South East",
			2015: "£200,000",
			2020: "£239,250",
			change: "0.2%",
			g2015: "£200,000",
			g2020: "£239,250",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Falkirk District Council",
			region: "Scotland",
			2015: "£38,611,854",
			2020: "£45,000,851",
			change: "0.17%",
			g2015: "£19,305,927",
			g2020: "£22,500,425",
			b2015: "£18,032,762",
			b2020: "£21,473,484",
			o2015: "£705,890",
			o2020: "£659,410",
			r2015: "£567,265",
			r2020: "£367,532",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Wakefield City Metropolitan District Council",
			region: "Yorkshire and Humber",
			2015: "£19,948,508",
			2020: "£23,094,589",
			change: "0.16%",
			g2015: "£13,209,818",
			g2020: "£14,790,174",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "£5,983,375",
			r2020: "£7,728,730",
			br2015: "£755,315",
			br2020: "£575,685",
		},
		{
			local: "Brentwood Borough Council",
			region: "East of England",
			2015: "£3,413,723",
			2020: "£3,907,304",
			change: "0.14%",
			g2015: "£3,413,723",
			g2020: "£3,907,304",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Harborough District Council",
			region: "East Midlands",
			2015: "£1,614,969",
			2020: "£1,841,251",
			change: "0.14%",
			g2015: "N/A",
			g2020: "N/A",
			b2015: "£289,672",
			b2020: "£609,344",
			o2015: "£1,325,297",
			o2020: "£1,224,535",
			r2015: "N/A",
			r2020: "£7,372",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Elmbridge Borough Council",
			region: "South East",
			2015: "£408,945",
			2020: "£465,059",
			change: "0.14%",
			g2015: "£408,945",
			g2020: "£465,059",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Isle of Anglesey Council",
			region: "Wales",
			2015: "£6,590,715",
			2020: "£7,450,307",
			change: "0.13%",
			g2015: "£6,590,715",
			g2020: "£7,450,307",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Ipswich Borough Council",
			region: "East of England",
			2015: "£18,508,604",
			2020: "£20,838,308",
			change: "0.13%",
			g2015: "£9,070,807",
			g2020: "£7,737,911",
			b2015: "£8,945,972",
			b2020: "£12,679,351",
			o2015: "£200,028",
			o2020: "£351,379",
			r2015: "£291,797",
			r2020: "£69,667",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "South Norfolk",
			region: "East of England",
			2015: "£3,977,000",
			2020: "£4,439,000",
			change: "0.12%",
			g2015: "£3,977,000",
			g2020: "£4,439,000",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Rhondda Cynon Taf County Borough Council",
			region: "Wales",
			2015: "£23,138,185",
			2020: "£25,767,539",
			change: "0.11%",
			g2015: "N/A",
			g2020: "N/A",
			b2015: "£22,826,972",
			b2020: "£25,022,443",
			o2015: "£82",
			o2020: "N/A",
			r2015: "£311,130",
			r2020: "£745,096",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Merthyr Tydfil Council",
			region: "Wales",
			2015: "£86,519,375",
			2020: "£95,691,297",
			change: "0.11%",
			g2015: "£86,519,375",
			g2020: "£95,691,297",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Southampton City Council",
			region: "South East",
			2015: "£7,296,000",
			2020: "£8,012,000",
			change: "0.1%",
			g2015: "N/A",
			g2020: "N/A",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "£6,700,000",
			r2020: "£7,600,000",
			br2015: "£596,000",
			br2020: "£412,000",
		},
		{
			local: "Herefordshire Council",
			region: "West Midlands",
			2015: "£7,794,165",
			2020: "£8,557,017",
			change: "0.1%",
			g2015: "N/A",
			g2020: "N/A",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "£7,269,049",
			r2020: "£7,435,460",
			br2015: "£525,116",
			br2020: "£1,121,557",
		},
		{
			local: "Devon County Council",
			region: "South West",
			2015: "£23,761,878",
			2020: "£26,065,864",
			change: "0.1%",
			g2015: "£6,624,155",
			g2020: "£5,336,138",
			b2015: "£15,121,707",
			b2020: "£9,310,150",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "£2,016,016",
			r2020: "£11,419,576",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Erewash Borough",
			region: "East Midlands",
			2015: "£636,986",
			2020: "£689,349",
			change: "0.1%",
			g2015: "£520,445",
			g2020: "£646,691",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "£116,542",
			r2020: "£42,658",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Bolton Metropolitan Borough Council",
			region: "North West",
			2015: "£33,223,136",
			2020: "£34,940,745",
			change: "0.05%",
			g2015: "£18,583,136",
			g2020: "£20,261,745",
			b2015: "£1,225,000",
			b2020: "£1,360,000",
			o2015: "£520,000",
			o2020: "£53,000",
			r2015: "£12,895,000",
			r2020: "£13,266,000",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Flintshire County Council",
			region: "Wales",
			2015: "£46,048,109",
			2020: "£47,353,337",
			change: "0.03%",
			g2015: "N/A",
			g2020: "N/A",
			b2015: "£43,456,962",
			b2020: "£40,426,684",
			o2015: "£167,979",
			o2020: "£61,914",
			r2015: "£2,423,168",
			r2020: "£6,864,739",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "London Borough of Merton",
			region: "London",
			2015: "£6,002,873",
			2020: "£6,031,042",
			change: "0.004%",
			g2015: "£1,918,487",
			g2020: "£1,316,306",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "£3,828,352",
			r2020: "£3,110,794",
			br2015: "£256,033",
			br2020: "£1,603,942",
		},
		{
			local: "Shetland Islands Council",
			region: "Scotland",
			2015: "£16,421,392",
			2020: "£16,479,510",
			change: "0.004%",
			g2015: "£9,521,865",
			g2020: "£6,430,082",
			b2015: "£6,899,527",
			b2020: "£10,049,428",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Argyll & Bute Council  ",
			region: "Scotland",
			2015: "£10,068,751",
			2020: "£10,093,933",
			change: "0.003%",
			g2015: "N/A",
			g2020: "N/A",
			b2015: "£7,641,764",
			b2020: "£8,719,618",
			o2015: "£260,390",
			o2020: "£766,083",
			r2015: "£2,166,597",
			r2020: "£608,232",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Kent County Council",
			region: "South East",
			2015: "£107,413,468",
			2020: "£106,212,340",
			change: "-0.01%",
			g2015: "£107,413,468",
			g2020: "£106,212,340",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Darlington Borough Council",
			region: "North East",
			2015: "£12,246,400",
			2020: "£11,905,682",
			change: "-0.03%",
			g2015: "£12,246,400",
			g2020: "£11,905,682",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Gosport Borough Council",
			region: "South East",
			2015: "£7,676,000",
			2020: "£7,292,000",
			change: "-0.05%",
			g2015: "£7,676,000",
			g2020: "£7,292,000",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "West Lothian Council",
			region: "Scotland",
			2015: "£58,408,203",
			2020: "£54,705,280",
			change: "-0.06%",
			g2015: "N/A",
			g2020: "N/A",
			b2015: "£42,296,203",
			b2020: "£44,798,280",
			o2015: "£6,294,000",
			o2020: "£1,338,000",
			r2015: "£9,818,000",
			r2020: "£8,569,000",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "East Dunbartonshire Council",
			region: "Scotland",
			2015: "£23,952,783",
			2020: "£22,330,847",
			change: "-0.07%",
			g2015: "N/A",
			g2020: "N/A",
			b2015: "£16,570,627",
			b2020: "£19,654,062",
			o2015: "£429,897",
			o2020: "£391,037",
			r2015: "£6,952,259",
			r2020: "£2,285,748",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Birmingham City Council",
			region: "West Midlands",
			2015: "£335,979,000",
			2020: "£310,983,000",
			change: "-0.07%",
			g2015: "N/A",
			g2020: "N/A",
			b2015: "£307,519,000",
			b2020: "£279,775,000",
			o2015: "N/A",
			o2020: "£2,619,000",
			r2015: "£28,460,000",
			r2020: "£28,589,000",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Orkney Islands Council",
			region: "Scotland",
			2015: "£15,325,503",
			2020: "£14,079,262",
			change: "-0.08%",
			g2015: "£8,672,295",
			g2020: "£6,939,383",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "£1,900,339",
			r2020: "£996,737",
			br2015: "£4,752,869",
			br2020: "£6,143,142",
		},
		{
			local: "Leicester City Council",
			region: "East Midlands",
			2015: "£116,944,040",
			2020: "£107,143,141",
			change: "-0.08%",
			g2015: "£49,865,509",
			g2020: "£45,797,193",
			b2015: "£67,078,531",
			b2020: "£61,345,948",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Wrexham County Borough Council",
			region: "Wales",
			2015: "£23,989,444",
			2020: "£21,822,617",
			change: "-0.09%",
			g2015: "N/A",
			g2020: "N/A",
			b2015: "£16,407,204",
			b2020: "£16,525,891",
			o2015: "£376,5",
			o2020: "£2,841,420",
			r2015: "£7,581,864",
			r2020: "£2,455,307",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Derbyshire Dales",
			region: "East Midlands",
			2015: "£962,710",
			2020: "£851,370",
			change: "-0.12%",
			g2015: "N/A",
			g2020: "N/A",
			b2015: "£760,862",
			b2020: "£825,618",
			o2015: "£188,397",
			o2020: "£25,752",
			r2015: "£13,452",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Preston City Council",
			region: "North West",
			2015: "£2,556,958",
			2020: "£2,259,333",
			change: "-0.12%",
			g2015: "£432,385",
			g2020: "£325,835",
			b2015: "£1,662,000",
			b2020: "£1,547,702",
			o2015: "£462,573",
			o2020: "£385,796",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Staffordshire County Council",
			region: "West Midlands",
			2015: "£29,560,000",
			2020: "£26,087,000",
			change: "-0.12%",
			g2015: "£8,760,000",
			g2020: "£9,727,000",
			b2015: "£20,800,000",
			b2020: "£16,360,000",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Lewes District Council",
			region: "South East",
			2015: "£7,545,961",
			2020: "£6,547,043",
			change: "-0.13%",
			g2015: "£7,545,961",
			g2020: "£6,547,043",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "South Lanarkshire Council",
			region: "Scotland",
			2015: "£21,757,756",
			2020: "£18,649,768",
			change: "-0.14%",
			g2015: "N/A",
			g2020: "N/A",
			b2015: "£20,348,329",
			b2020: "£17,280,713",
			o2015: "£185,713",
			o2020: "£108,767",
			r2015: "£1,223,714",
			r2020: "£1,260,287",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Surrey County Council",
			region: "South East",
			2015: "£290,664,951",
			2020: "£248,835,159",
			change: "-0.14%",
			g2015: "£184,857,752",
			g2020: "£166,124,028",
			b2015: "£51,048,761",
			b2020: "£41,985,343",
			o2015: "£3,487,644",
			o2020: "£4,990,351",
			r2015: "£51,270,794",
			r2020: "£35,735,437",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "London Borough of Hounslow",
			region: "London",
			2015: "£167,116,737",
			2020: "£140,745,924",
			change: "-0.16%",
			g2015: "£92,906,662",
			g2020: "£77,866,581",
			b2015: "£52,173,232",
			b2020: "£24,392,935",
			o2015: "£18,973",
			o2020: "£48,992",
			r2015: "£22,017,870",
			r2020: "£38,437,415",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Comhairle nan Eilean Siar (Western Isles Council)",
			region: "Scotland",
			2015: "£1,425,631",
			2020: "£1,198,097",
			change: "-0.16%",
			g2015: "£8,325",
			g2020: "£8,207",
			b2015: "£888,637",
			b2020: "£905,130",
			o2015: "£280,944",
			o2020: "£284,760",
			r2015: "£247,725",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "West Devon Borough Council",
			region: "South West",
			2015: "£39,693",
			2020: "£33,110",
			change: "-0.17%",
			g2015: "£39,693",
			g2020: "£33,110",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "East Ayrshire Council",
			region: "Scotland",
			2015: "£19,367,503",
			2020: "£16,146,526",
			change: "-0.17%",
			g2015: "N/A",
			g2020: "N/A",
			b2015: "£18,584,219",
			b2020: "£15,736,097",
			o2015: "£304,937",
			o2020: "£41,333",
			r2015: "£478,347",
			r2020: "£369,096",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Dundee City Council",
			region: "Scotland",
			2015: "£27,368",
			2020: "£22,737",
			change: "-0.17%",
			g2015: "£16,517",
			g2020: "£16,548",
			b2015: "£10,851",
			b2020: "£6,189",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "North Yorkshire County Council",
			region: "Yorkshire and Humber",
			2015: "£117,594,054",
			2020: "£97,549,823",
			change: "-0.17%",
			g2015: "£107,114,761",
			g2020: "£88,100,122",
			b2015: "£10,479,123",
			b2020: "£8,950,407",
			o2015: "£170",
			o2020: "£450",
			r2015: "N/A",
			r2020: "£498,845",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Cheshire West and Chester",
			region: "North West",
			2015: "£74,692,795",
			2020: "£61,958,873",
			change: "-0.17%",
			g2015: "£1,248,723",
			g2020: "£575,066",
			b2015: "£50,612,692",
			b2020: "£36,269,537",
			o2015: "£1,948,818",
			o2020: "£1,189,569",
			r2015: "£20,882,562",
			r2020: "£23,924,701",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "London Borough of Redbridge",
			region: "London",
			2015: "£43,696,331",
			2020: "£36,067,398",
			change: "-0.17%",
			g2015: "£43,696,331",
			g2020: "£35,471,135",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "£596,263",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "North Kesteven District Council",
			region: "East Midlands",
			2015: "£11,831,405",
			2020: "£9,656,165",
			change: "-0.18%",
			g2015: "£11,831,405",
			g2020: "£9,656,165",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Monmouthshire Council",
			region: "Wales",
			2015: "£28,535,623",
			2020: "£23,042,937",
			change: "-0.19%",
			g2015: "N/A",
			g2020: "N/A",
			b2015: "£18,917,021",
			b2020: "£10,580,189",
			o2015: "£2,739,661",
			o2020: "£3,107,680",
			r2015: "£6,878,941",
			r2020: "£9,355,068",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Blaenau Gwent County Borough",
			region: "Wales",
			2015: "£15,627,619",
			2020: "£12,231,748",
			change: "-0.22%",
			g2015: "£2,913,826",
			g2020: "£1,778,017",
			b2015: "£8,948,293",
			b2020: "£8,014,065",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "£3,565,800",
			r2020: "£2,439,666",
			br2015: "£199,700",
			br2020: "N/A",
		},
		{
			local: "Eastbourne Council",
			region: "South East",
			2015: "£8,621,868",
			2020: "£6,510,491",
			change: "-0.24%",
			g2015: "£8,621,868",
			g2020: "£6,510,491",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Sevenoaks District Council",
			region: "South East",
			2015: "£1,099,554",
			2020: "£812,525",
			change: "-0.26%",
			g2015: "£2,269",
			g2020: "£9,343",
			b2015: "£887,717",
			b2020: "£610,666",
			o2015: "£209,568",
			o2020: "£192,516",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "City of London Corporation",
			region: "London",
			2015: "£13,655,768",
			2020: "£10,015,996",
			change: "-0.27%",
			g2015: "£13,655,768",
			g2020: "£10,015,996",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "North Ayrshire Council",
			region: "Scotland",
			2015: "£21,674,377",
			2020: "£15,762,650",
			change: "-0.27%",
			g2015: "£461,805",
			g2020: "£391,199",
			b2015: "£20,616,329",
			b2020: "£15,081,554",
			o2015: "£64,218",
			o2020: "£59,305",
			r2015: "£532,025",
			r2020: "£230,592",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Perth & Kinross Council",
			region: "Scotland",
			2015: "£20,769,217",
			2020: "£14,914,734",
			change: "-0.2%",
			g2015: "N/A",
			g2020: "N/A",
			b2015: "£18,172,860",
			b2020: "£14,751,197",
			o2015: "£103,029",
			o2020: "£100,319",
			r2015: "£2,493,328",
			r2020: "£63,217",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "North Tyneside Council",
			region: "North East",
			2015: "£34,154,000",
			2020: "£23,544,000",
			change: "-0.31%",
			g2015: "N/A",
			g2020: "N/A",
			b2015: "£21,769,000",
			b2020: "£17,558,000",
			o2015: "£755,000",
			o2020: "£80,000",
			r2015: "£11,630,000",
			r2020: "£5,906,000",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Highland Council",
			region: "Scotland",
			2015: "£106,290,151",
			2020: "£72,151,386",
			change: "-0.32%",
			g2015: "£49,544,543",
			g2020: "£38,278,578",
			b2015: "£55,083,398",
			b2020: "£32,717,475",
			o2015: "£1,174,873",
			o2020: "£321,043",
			r2015: "£487,336",
			r2020: "£834,290",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Uttlesford District Council",
			region: "East of England",
			2015: "£3,161,935",
			2020: "£2,129,294",
			change: "-0.33%",
			g2015: "£111,951",
			g2020: "£192,445",
			b2015: "£3,049,984",
			b2020: "£1,936,849",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Caerphilly County Borough Council",
			region: "Wales",
			2015: "£78,843,614",
			2020: "£52,374,131",
			change: "-0.34%",
			g2015: "£46,734,620",
			g2020: "£30,190,727",
			b2015: "£29,747,556",
			b2020: "£20,026,552",
			o2015: "£476,306",
			o2020: "£843,357",
			r2015: "£1,885,132",
			r2020: "£1,313,495",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Allerdale Borough Council",
			region: "North West",
			2015: "£734,729",
			2020: "£487,636",
			change: "-0.34%",
			g2015: "£1,480",
			g2020: "£4,700",
			b2015: "£322,880",
			b2020: "£268,430",
			o2015: "£410,369",
			o2020: "£214,506",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "West Sussex County Council",
			region: "South East",
			2015: "£112,859",
			2020: "£74,865",
			change: "-0.34%",
			g2015: "£612",
			g2020: "£2,087",
			b2015: "£81,380",
			b2020: "£40,498",
			o2015: "£673",
			o2020: "£470",
			r2015: "£30,194",
			r2020: "£31,810",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Royal Borough of Kingston upon Thames",
			region: "London",
			2015: "£44,246,145",
			2020: "£28,523,098",
			change: "-0.36%",
			g2015: "£37,068,534",
			g2020: "£11,609,679",
			b2015: "£3,381,791",
			b2020: "£11,280,091",
			o2015: "£1,417,193",
			o2020: "£2,697,426",
			r2015: "£2,378,627",
			r2020: "£2,935,903",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Doncaster Metropolitan Borough Council",
			region: "Yorkshire and Humber",
			2015: "£110,284,755",
			2020: "£70,603,828",
			change: "-0.36%",
			g2015: "£64,812,923",
			g2020: "£40,538,225",
			b2015: "£27,616,406",
			b2020: "£15,338,849",
			o2015: "£20,593",
			o2020: "£42,785",
			r2015: "£17,834,833",
			r2020: "£14,683,968",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Inverclyde Council",
			region: "Scotland",
			2015: "£19,210,300",
			2020: "£12,132,618",
			change: "-0.3%",
			g2015: "£12,234,299",
			g2020: "£7,591,870",
			b2015: "£5,332,837",
			b2020: "£4,146,546",
			o2015: "£321,493",
			o2020: "£324,472",
			r2015: "£1,321,672",
			r2020: "£69,730",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Wiltshire Council",
			region: "South West",
			2015: "£42,166,414",
			2020: "£26,303,433",
			change: "-0.38%",
			g2015: "£3,449,560",
			g2020: "£3,430,493",
			b2015: "£9,693,766",
			b2020: "£3,286,923",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "£29,023,088",
			r2020: "£19,586,017",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "North Lanarkshire Council",
			region: "Scotland",
			2015: "£16,188,025",
			2020: "£10,070,916",
			change: "-0.38%",
			g2015: "£5,272,899",
			g2020: "£3,363,553",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "£9,275,102",
			r2020: "£5,910,269",
			br2015: "£1,640,024",
			br2020: "£797,093",
		},
		{
			local: "Torfaen County Borough",
			region: "Wales",
			2015: "£20,399,953",
			2020: "£12,610,342",
			change: "-0.38%",
			g2015: "£73,443",
			g2020: "£89,903",
			b2015: "£19,250,065",
			b2020: "£11,895,335",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "£1,002,316",
			r2020: "£625,104",
			br2015: "£74,129",
			br2020: "N/A",
		},
		{
			local: "Peterborough City Council",
			region: "East of England",
			2015: "£51,811,637",
			2020: "£31,791,941",
			change: "-0.39%",
			g2015: "£1,852,099",
			g2020: "£640,202",
			b2015: "£24,987,233",
			b2020: "£10,803,204",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "£24,972,305",
			r2020: "£20,348,535",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "London Borough of Lambeth",
			region: "London",
			2015: "£52,421,922",
			2020: "£31,871,011",
			change: "-0.39%",
			g2015: "N/A",
			g2020: "N/A",
			b2015: "£45,086,581",
			b2020: "£30,055,520",
			o2015: "£960,235",
			o2020: "£1,659,683",
			r2015: "£6,375,106",
			r2020: "£155,808",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Chesterfield Borough Council",
			region: "East Midlands",
			2015: "£5,552,301",
			2020: "£3,324,621",
			change: "-0.40%",
			g2015: "N/A",
			g2020: "N/A",
			b2015: "£5,301,532",
			b2020: "£3,201,711",
			o2015: "£169,084",
			o2020: "£77,521",
			r2015: "£81,685",
			r2020: "£45,388",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "East Lindsey District Council",
			region: "East Midlands",
			2015: "£936,142",
			2020: "£555,718",
			change: "-0.41%",
			g2015: "£936,142",
			g2020: "£555,718",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "South Lakeland District Council",
			region: "North West",
			2015: "£1,736,229",
			2020: "£1,015,335",
			change: "-0.42%",
			g2015: "£212,540",
			g2020: "£163",
			b2015: "£739,112",
			b2020: "£65,675",
			o2015: "£784,578",
			o2020: "£949,497",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Thanet District Council",
			region: "South East",
			2015: "£1,275,763",
			2020: "£719,761",
			change: "-0.44%",
			g2015: "N/A",
			g2020: "N/A",
			b2015: "£530,934",
			b2020: "£442,413",
			o2015: "£744,829",
			o2020: "£277,348",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "East Sussex County Council",
			region: "South East",
			2015: "£179,145,635",
			2020: "£98,751,307",
			change: "-0.45%",
			g2015: "£113,384,056",
			g2020: "£75,378,255",
			b2015: "£33,683,286",
			b2020: "£18,966,917",
			o2015: "£1,408,088",
			o2020: "£737,960",
			r2015: "£30,670,205",
			r2020: "£3,668,175",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Cornwall Council",
			region: "South West",
			2015: "£127,099,251",
			2020: "£69,169,530",
			change: "-0.46%",
			g2015: "£127,099,251",
			g2020: "£69,169,530",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Fareham Borough Council",
			region: "South East",
			2015: "£7,566,685",
			2020: "£3,663,506",
			change: "-0.52%",
			g2015: "£16",
			g2020: "£8,055",
			b2015: "£7,557,566",
			b2020: "£3,651,797",
			o2015: "£9,102",
			o2020: "£3,654",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Mid Ulster Council",
			region: "Northern Ireland",
			2015: "£12,875,939",
			2020: "£6,105,435",
			change: "-0.53%",
			g2015: "N/A",
			g2020: "N/A",
			b2015: "£6,199,746",
			b2020: "£1,141,934",
			o2015: "£6,676,193",
			o2020: "£4,963,501",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Wychavon District Council",
			region: "West Midlands",
			2015: "£7,223,624",
			2020: "£3,379,469",
			change: "-0.53%",
			g2015: "£3,646,422",
			g2020: "£1,713,156",
			b2015: "£2,631,777",
			b2020: "£866,915",
			o2015: "£344,586",
			o2020: "£769,398",
			r2015: "£600,839",
			r2020: "£30,000",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "London Borough of Brent",
			region: "London",
			2015: "£18,505,106",
			2020: "£8,294,593",
			change: "-0.55%",
			g2015: "N/A",
			g2020: "N/A",
			b2015: "£18,052,187",
			b2020: "£7,264,593",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "£452,919",
			r2020: "£1,030,000",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Sheffield City Council ",
			region: "Yorkshire and Humber",
			2015: "£361,730,000",
			2020: "£161,578,000",
			change: "-0.55%",
			g2015: "£180,865,000",
			g2020: "£80,789,000",
			b2015: "£135,388,000",
			b2020: "£76,784,000",
			o2015: "£350,000",
			o2020: "£124,000",
			r2015: "£45,127,000",
			r2020: "£3,881,000",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "North Hertfordshire District Council",
			region: "East of England",
			2015: "£2,403,700",
			2020: "£1,049,900",
			change: "-0.56%",
			g2015: "N/A",
			g2020: "N/A",
			b2015: "£1,814,200",
			b2020: "£921,400",
			o2015: "£506,900",
			o2020: "£48,100",
			r2015: "£82,600",
			r2020: "£80,400",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Central Bedfordshire Council",
			region: "East of England",
			2015: "£120,817,395",
			2020: "£50,836,073",
			change: "-0.58",
			g2015: "N/A",
			g2020: "N/A",
			b2015: "£68,183,593",
			b2020: "£28,491,991",
			o2015: "£801,091",
			o2020: "£590,382",
			r2015: "£51,832,709",
			r2020: "£21,753,700",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Dumfries and Galloway Council",
			region: "Scotland",
			2015: "£51,329,914",
			2020: "£19,956,681",
			change: "-0.6%",
			g2015: "£31,636,839",
			g2020: "£11,508,057",
			b2015: "£13,963,773",
			b2020: "£6,411,143",
			o2015: "£615,173",
			o2020: "£125,995",
			r2015: "£5,114,129",
			r2020: "£1,911,486",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "South Tyneside Metropolitan Borough Council",
			region: "North East",
			2015: "£21,743,309",
			2020: "£8,315,016",
			change: "-0.6%",
			g2015: "£7,703,034",
			g2020: "£1,948,492",
			b2015: "£13,665,066",
			b2020: "£5,716,623",
			o2015: "£6,374",
			o2020: "N/A",
			r2015: "£368,835",
			r2020: "£649,901",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Cambridge City Council/South Cambridgeshire District Council/Huntingdonshire District Council",
			region: "East of England",
			2015: "£15,137,480",
			2020: "£5,666,795",
			change: "-0.6%",
			g2015: "£15,137,480",
			g2020: "£5,666,795",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Belfast City Council",
			region: "Northern Ireland",
			2015: "£37,674,607",
			2020: "£13,904,611",
			change: "-0.6%",
			g2015: "£37,674,607",
			g2020: "£13,904,611",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "London Borough of Sutton",
			region: "London",
			2015: "£50,170,000",
			2020: "£18,368,000",
			change: "-0.6%",
			g2015: "£16,244,000",
			g2020: "£4,822,000",
			b2015: "£30,966,000",
			b2020: "£9,931,000",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "£2,960,000",
			r2020: "£3,615,000",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Ceredigion County Council",
			region: "Wales",
			2015: "£28,023,000",
			2020: "£8,652,000",
			change: "-0.7%",
			g2015: "£21,308,000",
			g2020: "£3,101,000",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "£6,485,000",
			r2020: "£5,109,000",
			br2015: "£230,000",
			br2020: "£442,000",
		},
		{
			local: "Oldham Metropolitan Borough Council",
			region: "North West",
			2015: "£59,584,000",
			2020: "£18,047,000",
			change: "-0.7%",
			g2015: "N/A",
			g2020: "N/A",
			b2015: "£52,146,000",
			b2020: "£6,132,000",
			o2015: "£20,000",
			o2020: "£394,000",
			r2015: "£7,418,000",
			r2020: "£11,521,000",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Newport Council",
			region: "Wales",
			2015: "£12,439,779",
			2020: "£3,458,379",
			change: "-0.7%",
			g2015: "N/A",
			g2020: "N/A",
			b2015: "£12,390,371",
			b2020: "£3,296,713",
			o2015: "£11,456",
			o2020: "£492",
			r2015: "£37,952",
			r2020: "£161,174",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Fife Council",
			region: "Scotland",
			2015: "£45,735,277",
			2020: "£11,975,106",
			change: "-0.7%",
			g2015: "£39,443,077",
			g2020: "£10,199,048",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "£11,456",
			o2020: "£492",
			r2015: "£6,265,302",
			r2020: "£1,774,898",
			br2015: "£26,898",
			br2020: "£1,159",
		},
		{
			local: "Manchester City Council",
			region: "North West",
			2015: "£80,935,928",
			2020: "£11,976,115",
			change: "-0.9%",
			g2015: "£57,937,742",
			g2020: "£11,976,115",
			b2015: "£22,998,186",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Hart District Council",
			region: "South East",
			2015: "£7,638,773",
			2020: "£158,572",
			change: "-0.98%",
			g2015: "N/A",
			g2020: "N/A",
			b2015: "£7,487,734",
			b2020: "£43,268",
			o2015: "£151,039",
			o2020: "£115,304",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Nuneaton & Bedworth",
			region: "West Midlands",
			2015: "£5,035,027",
			2020: "£0",
			change: "-1%",
			g2015: "N/A",
			g2020: "N/A",
			b2015: "£4,897,489",
			b2020: "N/A",
			o2015: "£137,539",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "London Borough of Waltham Forest",
			region: "London",
			2015: "£0",
			2020: "£63,883,446",
			change: "N/A",
			g2015: "N/A",
			g2020: "£63,883,446",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Broxtowe Borough Council",
			region: "East Midlands",
			2015: "£0",
			2020: "£7,000,000",
			change: "N/A",
			g2015: "N/A",
			g2020: "£7,000,000",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "West Berkshire Council",
			region: "South East",
			2015: "£0",
			2020: "£3,995,811",
			change: "N/A",
			g2015: "N/A",
			g2020: "£3,995,811",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Derbyshire County Council",
			region: "East Midlands",
			2015: "£0",
			2020: "£769,608",
			change: "N/A",
			g2015: "N/A",
			g2020: "£769,608",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Chichester District Council",
			region: "South East",
			2015: "£0",
			2020: "£649,200",
			change: "N/A",
			g2015: "N/A",
			g2020: "£649,200",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Knowsley Metropolitan Borough",
			region: "North West",
			2015: "£0",
			2020: "£1,080,014",
			change: "N/A",
			g2015: "N/A",
			g2020: "£807,629",
			b2015: "N/A",
			b2020: "£151,405",
			o2015: "N/A",
			o2020: "£120,980",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Oxfordshire County Council",
			region: "South East",
			2015: "£0",
			2020: "£67,048,053",
			change: "N/A",
			g2015: "N/A",
			g2020: "N/A",
			b2015: "N/A",
			b2020: "£18,027,340",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "£49,020,713",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Wigan Metropolitan Borough",
			region: "North West",
			2015: "£0",
			2020: "£55,144,943",
			change: "N/A",
			g2015: "N/A",
			g2020: "£46,919,693",
			b2015: "N/A",
			b2020: "£256,300",
			o2015: "N/A",
			o2020: "£11,825",
			r2015: "N/A",
			r2020: "£7,957,125",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Christchurch Borough Council",
			region: "South West",
			2015: "£0",
			2020: "£11,050,000",
			change: "N/A",
			g2015: "N/A",
			g2020: "N/A",
			b2015: "N/A",
			b2020: "£1,880,000",
			o2015: "N/A",
			o2020: "£1,500,000",
			r2015: "N/A",
			r2020: "£7,670,000",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Middlesbrough Borough Council",
			region: "North West",
			2015: "£0",
			2020: "£2,200,000",
			change: "N/A",
			g2015: "N/A",
			g2020: "N/A",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "£2,200,000",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "East Riding of Yorkshire Council",
			region: "Yorkshire and Humber",
			2015: "£0",
			2020: "£112,712,268",
			change: "N/A",
			g2015: "N/A",
			g2020: "£90,597,161",
			b2015: "N/A",
			b2020: "£20,588,928",
			o2015: "N/A",
			o2020: "£632,463",
			r2015: "N/A",
			r2020: "£893,716",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Sunderland City Council",
			region: "North East",
			2015: "£0",
			2020: "£8,806,330",
			change: "N/A",
			g2015: "N/A",
			g2020: "N/A",
			b2015: "N/A",
			b2020: "£8,558,852",
			o2015: "N/A",
			o2020: "£152,204",
			r2015: "N/A",
			r2020: "£95,274",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Slough Borough Council",
			region: "South East",
			2015: "£0",
			2020: "£1,732,450",
			change: "N/A",
			g2015: "N/A",
			g2020: "N/A",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "£1,711,500",
			br2015: "N/A",
			br2020: "£20,950",
		},
		{
			local: "N/A",
			region: "N/A",
			2015: "N/A",
			2020: "N/A",
			change: "N/A",
			g2015: "N/A",
			g2020: "N/A",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Total",
			region: "N/A",
			2015: "£4,633,470,611",
			2020: "£4,769,168,102",
			change: "0.03%",
			g2015: "N/A",
			g2020: "N/A",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
		{
			local: "Average",
			region: "N/A",
			2015: "£27,416,986",
			2020: "£2,821,993",
			change: "2%",
			g2015: "N/A",
			g2020: "N/A",
			b2015: "N/A",
			b2020: "N/A",
			o2015: "N/A",
			o2020: "N/A",
			r2015: "N/A",
			r2020: "N/A",
			br2015: "N/A",
			br2020: "N/A",
		},
	]);

	let newData = data;

	const getSearchData = (data) => {
		newData = data.filter((row) => {
			if (row.local.toLowerCase().includes(searchWord)) {
				return row;
			}
		});
	};

	if (changed === "field") {
		getSearchData(data);
	}

	return (
		<Fragment>
			<Table disableSortRemove columns={columns} data={newData} />
		</Fragment>
	);
}

export default TableFilters;
